import { render, staticRenderFns } from "./C00G1010.vue?vue&type=template&id=b07af26e"
import script from "./C00G1010Controller.ts?vue&type=script&lang=ts&external"
export * from "./C00G1010Controller.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports